(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["explore-collection-submenu"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('.header__nav-item:has([data-tbl-explore])').forEach(menu => {
    if (menu.dataset.tblMegaInitialized) return;
    menu.dataset.tblMegaInitialized = 'true';
    const branches = [...menu.querySelectorAll('[data-tbl-explore]')];
    const inner = menu.querySelector('.header__nav-dropdown-inner');
    const fitPanel = () => {
      const panel = branches.find(branch => !branch.querySelector('.tbl-explore__panel').hidden)?.querySelector('.tbl-explore__panel');
      const sidebar = menu.querySelector('.header__nav--group-link');
      if (panel && inner && sidebar) {
        const styles = getComputedStyle(inner);
        const borderHeight = parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
        inner.style.setProperty('--tbl-explore-height', `${Math.ceil(Math.max(panel.scrollHeight, sidebar.scrollHeight) + borderHeight)}px`);
      }
    };
    window.addEventListener('resize', fitPanel);
    document.fonts?.ready.then(fitPanel);
    const close = branch => {
      branch.querySelector('button').setAttribute('aria-expanded', 'false');
      branch.querySelector('.tbl-explore__panel').hidden = true;
    };
    const open = branch => {
      branches.forEach(other => { if (other !== branch) close(other); });
      branch.querySelector('button').setAttribute('aria-expanded', 'true');
      branch.querySelector('.tbl-explore__panel').hidden = false;
      fitPanel();
    };
    const dropdown = menu.querySelector('.header__nav-dropdown');
    const ensureOpen = () => {
      delete menu.dataset.tblMegaClosed;
      dropdown?.classList.add('is-visible');
      menu.closest('.header')?.classList.add('is-megamenu-open');
      if (!branches.some(branch => branch.querySelector('button').getAttribute('aria-expanded') === 'true')) open(branches[0]);
    };
    const trigger = menu.querySelector(':scope > a');
    menu.addEventListener('mouseenter', ensureOpen);
    trigger?.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') { event.preventDefault(); ensureOpen(); branches[0].querySelector('button').focus(); }
    });
    menu.addEventListener('pointerenter', ensureOpen);
    menu.addEventListener('focusin', ensureOpen);
    branches.forEach(branch => {
      const button = branch.querySelector('button');
      branch.querySelector('.tbl-explore__row').addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') open(branch);
      });
      button.addEventListener('click', () => open(branch));
      button.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault(); open(branch); branch.querySelector('.tbl-explore__panel a')?.focus();
        }
      });
    });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      event.preventDefault(); event.stopPropagation();
      const trigger = menu.querySelector(':scope > a');
      trigger?.focus();
      branches.forEach(close);
      menu.querySelector('.header__nav-dropdown')?.classList.remove('is-visible');
      menu.closest('.header')?.classList.remove('is-megamenu-open');
      menu.dataset.tblMegaClosed = 'true';
    });
    document.addEventListener('pointerdown', event => {
      if (!menu.contains(event.target)) {
        branches.forEach(close);
        dropdown?.classList.remove('is-visible');
        menu.closest('.header')?.classList.remove('is-megamenu-open');
        menu.dataset.tblMegaClosed = 'true';
      }
    });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sweaty-yeti-configurator"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sweaty-yeti-configurator]').forEach((configurator) => {
    const total = configurator.querySelector('[data-config-total]');
    const totalInput = configurator.querySelector('[data-config-total-input]');
    const summary = configurator.querySelector('[data-config-summary]');
    const properties = configurator.querySelector('[data-config-properties]');
    const cartNote = configurator.querySelector('[data-config-cart-note]');
    const basePrice = Number(configurator.dataset.basePrice || 0);
    const currency = configurator.dataset.currency || 'USD';
    const formatCurrency = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(amount / 100);

    const updateConfiguration = () => {
      const selected = Array.from(configurator.querySelectorAll('[data-config-input]:checked'));
      const additions = selected.reduce((sum, input) => sum + Number(input.dataset.cents || 0), 0);
      const estimatedTotal = formatCurrency(basePrice + additions);
      const selections = selected.map((input) => `${input.dataset.group}: ${input.dataset.label}`);

      total.textContent = estimatedTotal;
      totalInput.value = `${configurator.dataset.estimatedLabel}: ${estimatedTotal}`;

      // Carry the configuration onto the order line, and say plainly that the
      // cart is charging the base build only.
      if (properties) {
        properties.innerHTML = '';
        selected.forEach((input) => {
          const cents = Number(input.dataset.cents || 0);
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = `properties[Requested quote only - ${input.dataset.group}]`;
          field.value = cents > 0
            ? `${input.dataset.label} (+${formatCurrency(cents)})`
            : input.dataset.label;
          properties.appendChild(field);
        });
      }

      if (cartNote) {
        cartNote.textContent = additions > 0
          ? `Checkout charges the base build at ${formatCurrency(basePrice)}. The ${formatCurrency(additions)} of upgrades you chose is not charged here; we confirm and invoice it with your quote.`
          : `Checkout charges the base build at ${formatCurrency(basePrice)}. Upgrades you choose above are quoted separately.`;
      }
      summary.value = [
        configurator.dataset.summaryIntro,
        '',
        `${configurator.dataset.estimatedLabel}: ${estimatedTotal}`,
        '',
        ...selections,
      ].join('\n');
    };

    configurator.addEventListener('change', updateConfiguration);
    updateConfiguration();
  });
  } catch(e) { console.error(e); }
})();

})();
